import { CommonModule } from '@angular/common';
import { Component, inject, Input, input, OnInit, signal } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { AccommodationTypeInterface } from '@valk-nx/compositions/ui-availability-widget/src/lib/availability-widget.component.interface';
import { fallbackLanguage } from '@valk-nx/core/lib/core';
import { AvailabilityWidgetComponent } from '@valk-nx/storyblok/components/availability-widget/src/lib/availability-widget';
import { CarouselComponent } from '@valk-nx/storyblok/components/carousel/src/lib/carousel';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { Carousel } from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

@Component({
	selector: 'sb-carousel-with-availability-widget',
	templateUrl: './carousel-with-availability-widget.html',
	imports: [
		CommonModule,
		CarouselComponent,
		AvailabilityWidgetComponent,
		StoryblokDirective,
	],
})
export class CarouselWithAvailabilityWidgetComponent
	extends StoryblokRootDirective
	implements OnInit
{
	private readonly translate = inject(TranslateService);
	readonly currentLanguage = signal<string>(fallbackLanguage);

	@Input() blocks: Carousel[] = [];
	@Input({ required: true }) hotelGUID!: string;
	hotelSlug = input<string | undefined>(undefined);
	accommodationTypes = input<AccommodationTypeInterface[] | undefined>(
		undefined,
	);
	openInNewTab = input<boolean>(false);

	carousel!: Carousel;

	constructor() {
		super();
		this.currentLanguage.set(
			this.translate.getCurrentLang() ?? this.translate.getFallbackLang(),
		);
	}

	ngOnInit() {
		this.carousel = this.blocks.find((x) => x.component === 'carousel');
	}
}
